import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabaseMutationFn, useSupabaseTypedClient } from 'hooks/reactQuery';
import { useToastWrapper } from 'hooks/useToastWrapper';

import { useCurrentUser } from 'auth/CurrentUserProvider';
import { DeleteAssetParams, EdgeFunctionName } from 'types/edgeFunctions';
import { TanstackQueryName } from 'types/frontend';

export const useDeleteAssetMutation = () => {
  const supabase = useSupabaseTypedClient();
  const queryClient = useQueryClient();
  const { id: userId } = useCurrentUser();
  const { toastSuccess, toastError } = useToastWrapper();

  return useMutation<string, string, DeleteAssetParams>({
    mutationFn: supabaseMutationFn(({ assetId }) =>
      supabase.functions.invoke<string>(EdgeFunctionName.DeleteAsset, {
        body: { assetId } as DeleteAssetParams,
      })
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetUserAssets, userId] });
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetCurrentUser, userId] });
      toastSuccess('File deleted');
    },
    onError: () => {
      toastError("Can't delete file");
    },
  });
};
